import { useRef } from 'react';
import './ModalBackdrop.css';

interface Props {
  onClick?: () => void;
}

const ModalBackdrop: React.FC<Props> = ({ onClick }) => {
  const touchStartY = useRef<number | null>(null);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    if (touchStartY.current === null) return;
    const touchEndY = e.changedTouches[0].clientY;
    const diffY = touchEndY - touchStartY.current;
    if (diffY > 60) {
      if (onClick) {
        onClick();
      }
    }
    touchStartY.current = null;
  };
  return (
    <div
      className='modal-backdrop'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(38, 39, 41, 0.65)',
        backdropFilter: 'blur(2px)',
        zIndex: 9998, // Slightly below modal
        transition: 'opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: 1,
      }}
      onClick={onClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    />
  );
};

export default ModalBackdrop;
